<template>
  <div style="height:100%">
    <div class="calendar-task-tools">
      <div class="calendar-task-tools-left">
          <div>
              <!-- <button style="font-size: 16px" class="btn-calendar" @click="prevMonth()">
                  «
              </button> -->
              <button style="font-size: 16px" class="btn-calendar" @click="prev()">‹</button>
          </div>
          <span class="calendar-task-date">
              {{currentDateShow}}
          </span>
          <div>
              <button style="font-size: 16px" class="btn-calendar" @click="next()">›</button>
              <!-- <button style="font-size: 16px" class="btn-calendar" @click="nextMonth()">
                  »
              </button> -->
          </div>
          <div>
            
            <template v-if="loading">
                <a-spin />
            </template>
            <template v-else>
              <a-button type="primary" ghost style="margin-left:50px;margin-right: 10px;" @click="onSelectedAll(true)">全选</a-button>
              <a-button type="primary" ghost style="margin-right: 50px;" @click="onSelectedAll(false)">全不选</a-button>
              <a-button type="primary" style="margin-right: 10px" @click="batchConfirm">批量确认</a-button>
              <a-button type="danger" @click="batchReject">批量拒绝</a-button>
            </template>
          </div>
      </div>
      <div class="calendar-task-tools-right">
          <ul class="calendar-task-type-list">
              <li @click="changeType('month')" :class="{ active: type == 'month' }">Month</li>
              <li @click="changeType('week')" :class="{ active: type == 'week' }">Week</li>
          </ul>
      </div>
    </div>
    <div style="height: calc(100% - 62px)">
      <vxe-grid 
          border
          resizable
          stripe
          highlight-current-row
          show-overflow
          show-header-overflow
          height="auto"
          header-align="center"
          align="center"
          :checkbox-config="{checkField: 'check'}"
          :columns="columns" :data="records">
        <template v-slot:checkbox="{row}">
          <a-checkbox :indeterminate="row.indeterminate" 
            :checked="row.check" @change="onCheckRowChange(row)"></a-checkbox>
        </template>
        <template v-slot:date="{ row, column }">
          <!-- {{column.property}} {{columnIndex}} -->
          <div v-for="item in row.details[column.property]" :key="item.id"> 
            <a-checkbox v-if="item.state == 0" :checked="item.check" @change="onCheckChange(row,item)"></a-checkbox>
            <a-popover title="备注">
              <template slot="content">
                {{item.content}}
              </template>
              <a-button type="link">{{item.duration}}</a-button>
            </a-popover>
            <a-icon v-if="item.state == 1" type="check-circle" theme="twoTone" two-tone-color="#52c41a" style="font-size:16px" />
            <a-popover v-else-if="item.state == -1" title="拒绝原因">
              <template slot="content">
                {{item.approvalContent}}
              </template>
              <a-icon type="close-circle" theme="twoTone" two-tone-color="#eb2f96" style="font-size:16px; cursor:pointer;" />
            </a-popover>
            
            <template v-else>
                <a-button type="primary" ghost size="small" style="margin-right:5px;" @click="confirm(item)">确认</a-button>
                <a-button type="primary" ghost size="small" @click="reject(item)">拒绝</a-button>
            </template>
          </div>
        </template>
      </vxe-grid>
    </div>
    <a-modal
        title="拒绝"
        okText="拒绝"
        cancelText="取消"
        :visible="visibleRejectModal"
        @ok="submitReject"
        @cancel="closeRejectModal"
    >
        <a-form :model="form" layout="vertical">
            <a-form-model-item label="拒绝原因">
                <a-input v-model="form.approvalContent" type="textarea" />
            </a-form-model-item>
        </a-form>
    </a-modal>
  </div>
</template>
<script>
export default {
  data () {
    return {
      currentDate: new Date(),
      type: '', // month / week
      columns: [],
      records: [],
      // records: [{
      //   userName: 'A001',
      //   projectName: 'SDfasdf',
      //   check: undefined,
      //   indeterminate: false,
      //   details: {'05-31':[{
      //     id: 1,
      //     duration: 9.5,
      //     content: 'test',
      //     state: 0,
      //     check: undefined
      //   }],
      //   '06-03':[{
      //     id: 2,
      //     duration: 9.5,
      //     content: 'test1',
      //     state: 0
      //   },{
      //     id: 3,
      //     duration: 9.5,
      //     content: 'test1aaaaaa aaaaaaaa aaa aaaaaaaaaaa',
      //     state: 0
      //   },{
      //     id: 4,
      //     duration: 9.5,
      //     content: '这就是PandaVPN -2021最受欢迎的VPN工具. 在继续之前，请回答几个有关VPN的问题。',
      //     state: -1,
      //     approvalContent: '艾达大师傅'
      //   }]
      //   }
      // }],
      form: {
        approvalContent: ''
      },
      item: {},
      batchItems: [],
      batchIds: [],
      isBatchReject: false,
      visibleRejectModal: false,
      loading: false
    }
  },
  created() {
    this.changeType('week');
  },
  computed: {
    currentDateShow() {
      if(this.currentDate){
        return this.currentDate.getFullYear() + '-'
          + (this.currentDate.getMonth() + 1 + '').padStart(2,'0') + '-'
          + (this.currentDate.getDate() + '').padStart(2,'0');
      }
    }
  },
  watch: {
    currentDate(newValue){
      this.columns = [{
        field: 'userName',
        title: '人员',
        width: '120px',
      },{
        field: 'projectName',
        title: '项目',
        minWidth: '150px',
      },{
        width: '40px',
        title: '选',
        slots: { default: 'checkbox'}
      }]
      if (this.type == 'month') {
        let date = new Date(this.currentDate.getTime())
        let index = 0
        while(date.getMonth() == this.currentDate.getMonth()){
          this.columns.push({
            // field: 'date' + index,
            field: ('' + (date.getMonth() + 1)).padStart(2,'0') + '-' + (date.getDate() + '').padStart(2,'0'),
            title: ('' + (date.getMonth() + 1)).padStart(2,'0') + '/' + (date.getDate() + '').padStart(2,'0'),
            width: '170px',
            slots: { default: 'date'}
          });
          date = new Date(date.getTime())
          date.setDate(date.getDate() + 1)
          index = index + 1
        }
      } else if (this.type == 'week') {
        let date = new Date(this.currentDate.getTime())
        for(let i = 0; i < 7;i++){
          this.columns.push({
            // field: 'details[' + i + ']',
            field: ('' + (date.getMonth() + 1)).padStart(2,'0') + '-' + (date.getDate() + '').padStart(2,'0'),
            title: ('' + (date.getMonth() + 1)).padStart(2,'0') + '/' + (date.getDate() + '').padStart(2,'0'),
            width: '170px',
            slots: { default: 'date'}
          });
          date = new Date(date.getTime())
          date.setDate(date.getDate() + 1)
        }
      }
      // 查询数据，并显示
      this.query()
    }
  },
  methods: {
    prev() {
        let date = this.currentDate
        if (this.type == 'month') {
          date.setDate(1)
          date.setMonth(this.currentDate.getMonth() - 1)
        } else if (this.type == 'week') {
          date.setDate(this.currentDate.getDate() - 7)
        }

        this.currentDate = ""
        this.currentDate = date
        
    },
    next() {
        let date = this.currentDate
        if (this.type == 'month') {
          date.setDate(1)
          date.setMonth(this.currentDate.getMonth() + 1)
        } else if (this.type == 'week') {
          date.setDate(this.currentDate.getDate() + 7)
        }
        this.currentDate = ""
        this.currentDate = date
    },
    /** 设置日历展现方式 */
    changeType(type) {
        if (this.type !== type) {
            this.type = type;
            let date = new Date()
            switch (this.type) {
                case 'month':
                    // 参数：当前日期所在月的1号
                    date.setDate(1) 
                    break;
                case 'week':
                    // 参数：当前日期所在周的周一
                    date.setDate(date.getDate() - date.getDay() + 1)
                    break;
                default:
                    break;
            }
            
            this.currentDate = ""
            this.currentDate = date;
        }
    },
    query() {
      let data = {
        startDateStr: this.$moment(this.currentDate).format("YYYY-MM-DD")
      }
      if (this.type == 'month') {
        data.endDateStr = this.$moment(this.currentDate).add(1, 'months').format("YYYY-MM-DD")
      } else {
        data.endDateStr = this.$moment(this.currentDate).add(7, 'days').format("YYYY-MM-DD")
      }
      this.$axios.post('/api/Working/QueryApprovalData?startDate=' + data.startDateStr 
        + '&endDate=' + data.endDateStr).then(res => { 
          this.records = res.data
      });
    },
    // 确认
    confirm(item){
      // console.log(item)
      // 提交确认
      this.$axios.post('/api/Working/ConfirmWorkingData?ID=' + item.id).then(res => { 
          if(res.data.result){
            // this.$message.success(res.data.msg);
            item.state = 1
          } else{
            this.$message.error(res.data.msg);
          }
      });
    },
    batchConfirm(){
      // >> 获取ID清单
      let checkedItems = []
      let checkedIds = []
      for(let rowIndex in this.records){
        let row = this.records[rowIndex]
        for(let date in row.details){
          for(var i in row.details[date]){
            let wm = row.details[date][i]
            if(wm.state == 0 && wm.check){
              checkedItems.push(wm)
              checkedIds.push(wm.id)
            }
          }
        }
      }
      if(checkedIds.length == 0){
        this.$message.error("未选中记录")
        return
      }
      let data = {
        ids: checkedIds
      }
        
      this.loading = true
      this.$axios.post('/api/Working/BatchConfirmWorkingData', data ).then(res => {
          this.loading = false
          if(res.data.result){
            // this.$message.success(res.data.msg);
            // 刷新显示数据
            for(let i in checkedItems){
              checkedItems[i].state = 1
            }
            // 还原状态
            this.item = undefined
            this.isBatchReject = false
            this.form.approvalContent = ''
            this.visibleRejectModal = false
            this.onSelectedAll(false)
          } else{
            this.$message.error(res.data.msg);
          }
      });
    },
    // 弹出拒绝对话框
    reject(item){
      // console.log(item)
      this.item = item
      this.isBatchReject = false
      this.visibleRejectModal = true
    },
    batchReject(){
      this.batchItems = []
      this.batchIds = []
      for(let rowIndex in this.records){
        let row = this.records[rowIndex]
        for(let date in row.details){
          for(var i in row.details[date]){
            let wm = row.details[date][i]
            if(wm.state == 0 && wm.check){
              this.batchItems.push(wm)
              this.batchIds.push(wm.id)
            }
          }
        }
      }
      if(this.batchIds.length == 0){
        this.$message.error("未选中记录")
        return
      }
      this.isBatchReject = true
      this.visibleRejectModal = true
    },
    submitReject(){
      if(this.isBatchReject){
        // 提交批量拒绝        
        let data = {
          ids: this.batchIds,
          approvalContent: this.form.approvalContent
        }
        
        this.$axios.post('/api/Working/BatchRejectWorkingData', data ).then(res => {
            if(res.data.result){
              // this.$message.success(res.data.msg);
              // 刷新显示数据
              for(let i in this.batchItems){
                this.batchItems[i].state = -1
                this.batchItems[i].approvalContent = data.approvalContent
              }
              // 还原状态
              this.item = undefined
              this.isBatchReject = false
              this.form.approvalContent = ''
              this.visibleRejectModal = false
              this.onSelectedAll(false)
            } else{
              this.$message.error(res.data.msg);
            }
        });
      } else{
        // 提交拒绝
        let data = {
          id: this.item.id,
          approvalContent: this.form.approvalContent
        }
        this.$axios.post('/api/Working/RejectWorkingData', data ).then(res => {
            if(res.data.result){
              // this.$message.success(res.data.msg);
              // 刷新显示数据
              this.item.approvalContent = data.approvalContent
              this.item.state = -1
              // 还原状态
              this.visibleRejectModal = false
              this.item = undefined
              this.form.approvalContent = ''
            } else{
              this.$message.error(res.data.msg);
            }
        });
      }
    },
    closeRejectModal() {
      this.item = undefined
      this.visibleRejectModal = false
    },
    onCheckRowChange(row) {
      if(row.indeterminate || !row.check){
        row.indeterminate = false
        row.check = true
      } else {
        row.check = false
      }
      for(var date in row.details){
        for(var i in row.details[date]){
          if(row.details[date][i].state == 0){
            row.details[date][i].check = row.check
          }
        }
      }
    },
    onCheckChange(row,item){
      item.check = !item.check
      for(var date in row.details){
        for(var i in row.details[date]){
          if(row.details[date][i].state == 0 
              && row.details[date][i].check != item.check){
            row.indeterminate = true
            return;
          }
        }
      }
      row.indeterminate = false
      row.check = item.check
    },
    onSelectedAll(check){
      for(let rowIndex in this.records){
        let row = this.records[rowIndex]
        row.indeterminate = false
        row.check = check
        for(let date in row.details){
          for(var i in row.details[date]){
            if(row.details[date][i].state == 0){
              row.details[date][i].check = check
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
button.btn-calendar {
    cursor: pointer;
    display: inline-block;
    line-height: 30px;
    border: 1px solid #d9d9d9;
    color: rgba(0, 0, 0, 0.65);
    padding: 0px 12px;
    border-radius: 4px;
    font-size: 14px;
    transition: 0.3s;
    background: white;
    margin: 0px 6px;
    outline: none;

    &:hover {
        color: #1890ff;
    }

    &.active {
        color: #1890ff;
        background: #fff;
        border-color: #1890ff;
    }
}

.calendar-task-tools {
  user-select: none;
  display: flex;
  justify-content: space-between;
  padding: 15px 10px;
  box-sizing: border-box;

  > .calendar-task-tools-left {
      display: flex;

      > .calendar-task-date {
          display: inline-block;
          line-height: 32px;
          padding: 0px 10px;
          font-size: 14px;
      }
  }

  > .calendar-lengend {
      display: flex;
      ul {
          padding-left: 4px;
          padding-right: 4px;
          margin: 0px;
          border-radius: 4px;
          margin-top: 6px;
          margin-bottom: 4px;

          li {
              box-sizing: border-box;
              list-style: none;
              border-radius: 3px;
              text-align: left;
              font-size: 12px;
              color: #666666;
              vertical-align: middle;
              display: inline-block;
              margin-right: 10px;

              &:before {
                  content: '';
                  display: inline-block;
                  width: 9px;
                  height: 9px;
                  background-color: #faad14;
                  border-radius: 50%;
                  margin-right: 6px;
                  vertical-align: middle;
              }
          }
      }
  }

  > .calendar-task-tools-right {
      > .calendar-task-type-list {
          display: inline-block;
          padding-left: 0px;
          margin: 0px;

          > li {
              cursor: pointer;
              display: inline-block;
              line-height: 30px;
              color: rgba(0, 0, 0, 0.65);
              border: 1px solid #d9d9d9;
              padding: 0px 12px;
              border-top-right-radius: 4px;
              border-bottom-right-radius: 4px;
              font-size: 14px;
              transition: 0.3s;
              outline: none;

              &:hover {
                  color: #1890ff;
              }

              &.active {
                  color: #1890ff;
                  background: #fff;
                  border-color: #1890ff;

                  + li {
                      border-left-color: #1890ff;
                  }
              }

              &:first-child {
                  border-right: none;
                  border-top-left-radius: 4px;
                  border-bottom-left-radius: 4px;
                  border-top-right-radius: 0px;
                  border-bottom-right-radius: 0px;
              }
          }
      }
  }
}
.ant-btn {
  padding: 0 5px !important;
}
</style>
